import LocationProvider from '@hellodarwin/core/lib/features/providers/location-provider';
import { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useClientAnalytics } from '../analytics/use-client-analytics';

const LocationProviderWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const analytics = useClientAnalytics();
  const lastTrackedPathname = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !analytics.isReady()) return;
    if (lastTrackedPathname.current === pathname) return;

    analytics.page();
    lastTrackedPathname.current = pathname;
  }, [analytics, pathname]);

  return (
    <LocationProvider
      pathname={pathname}
      search={search}
      navigate={navigate}
      LinkElement={Link}
    >
      {children}
    </LocationProvider>
  );
};

export default LocationProviderWrapper;
